import React,{useEffect} from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import RoutesConstants from '../../shared/components/Routes/routes.constants';

const Logout = (props:any) =>{
    useEffect(() => {
        props.logout();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
    return <Redirect to={RoutesConstants.Login} />;
};
    

const mapStateToProps = (state: IState) => ({
	
});

const mapDispatchToProps = (dispatch:any) => {
	return {
		logout: () => dispatch(actions.logout()),
	};
};

export default connect(mapStateToProps,mapDispatchToProps)(Logout);